// Library imports
import React, { useState, useEffect } from 'react';
// Component imports
import CompareList from '../../../../components/CompareList';
import LoadingSpinner from '../../../../components/LoadingSpinner';
// Util imports
import { shortName } from '../../../../utils/strings';
import { keyFactorData } from './utils';
import { readableColor } from '../../utils';
// Styled components
import { InnerContent } from '../styles';

const KeyFactors = ({ sport, game }) => {
    const [tabs, setTabs] = useState({ type1: 'offense', type2: 'offense' });
    const [awayData, setAwayData] = useState([]);
    const [homeData, setHomeData] = useState([]);
    const [awayLabels, setAwayLabels] = useState([]);
    const [homeLabels, setHomeLabels] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        async function fetchData() {
            try {
                setLoading(true);
                const awayFactorType = tabs.type1 === 'offense' ? 'off' : 'def';
                const homeFactorType = tabs.type2 === 'offense' ? 'off' : 'def';
                const { teamFactors: awayFactors, labels: awayLabels } = await keyFactorData(
                    sport,
                    game.awayTeam,
                    game.homeTeam,
                    awayFactorType,
                    homeFactorType,
                );
                setAwayLabels(awayLabels);
                setAwayData(awayFactors);
            } catch (error) {
                console.log(`Error getting key factor objects for away team ${sport}. ${error.message}`);
            } finally {
                setLoading(false);
            }
        }
        fetchData();
    }, [tabs.type1, tabs.type2]);

    useEffect(() => {
        async function fetchData() {
            try {
                setLoading(true);
                const homeFactorType = tabs.type2 === 'offense' ? 'off' : 'def';
                const awayFactorType = tabs.type1 === 'offense' ? 'off' : 'def';
                const { teamFactors: homeFactors, labels: homeLabels } = await keyFactorData(
                    sport,
                    game.homeTeam,
                    game.awayTeam,
                    homeFactorType,
                    awayFactorType,
                );
                setHomeLabels(homeLabels);
                setHomeData(homeFactors);
            } catch (error) {
                console.log(`Error getting key factor objects for home team ${sport}. ${error.message}`);
            } finally {
                setLoading(false);
            }
        }
        fetchData();
    }, [tabs.type1, tabs.type2]);

    return (
        <InnerContent fluid>
            {loading ? (
                <LoadingSpinner containerStyle={{ minHeight: '200px', width: '100%' }} />
            ) : (
                <CompareList
                    labels={[...new Set([...awayLabels, ...homeLabels])]}
                    dataSetOneTitle={shortName(game.awayTeam)}
                    dataSetOneTitleColor={readableColor(game.awayTeam.color)}
                    dataSetOneLogo={game.awayTeam.logoUrl}
                    dataSetOne={awayData}
                    dataSetTwoTitle={shortName(game.homeTeam)}
                    dataSetTwoTitleColor={readableColor(game.homeTeam.color)}
                    dataSetTwoLogo={game.homeTeam.logoUrl}
                    dataSetTwo={homeData}
                    tabs={['offense', 'defense']}
                    activeTabs={tabs}
                    setTabs={setTabs}
                    loading={loading}
                />
            )}
        </InnerContent>
    );
};

export default KeyFactors;
